module.exports = __webpack_public_path__ + "img/portrait_night_sky.e98a37e3.jpeg";